module.exports = __webpack_public_path__ + "media/images/brands/marque-majirel-47a98dde0befb06e24d336b443953b14.jpg";